import CustomButton from "../kits/custom-button/CustomButton";
import useAxios from "../../services/useAxios";
import React, { useEffect, useState, useContext } from "react";
import AuthenticationContext from "../../context/Authentication/AuthenticationContext";
import ShoppingCartItemContext from "../../context/ShoppingCart/ShoppingCartItemContext";

export default function DeleteAddress({
  id,
  title,
  setIsOpenDrawer,
  updateAddress,
}) {
  const {
    loading,
    execute: Delete,
    cancel,
  } = useAxios("api/Update_UsersAddress");
  const auth = useContext(AuthenticationContext);
  const [updater, setUpdater] = useState(false);
  const { shoppingList, updateShoppingList } = useContext(
    ShoppingCartItemContext
  );
  useEffect(() => {}, [updater]);

  async function DeleteAddress() {
    await Delete({
      keyvalues: `status,-1`,
      conditions: `id/=/${id}`,
    }).then((res) => {
      if (res.status == 1) {
        setIsOpenDrawer(false);
        auth.refreshAddresses().finally(() => {
          updateShoppingList();
          updateAddress();
        });
        setUpdater(!updater);
      }
    });
  }
  return (
    <div className="delete-address">
      <>
        <div className="text-start mr-t-20 mr-b-16 title-h3-b">
          <p>حذف آدرس</p>
        </div>
        <div>
          <p className="desc-c-l">آیا می‌خواهید آدرس {title} را حذف کنید؟</p>
        </div>
        <div
          className="d-flex justify-content-between  w-100 pd-x-20 pd-y-20"
          // style={{ bottom: "2rem" }}
        >
          <CustomButton
            className="w-50"
            buttonStyle=""
            state="default"
            size="medium"
            onClick={() => {
              setIsOpenDrawer(false);
            }}
          >
            انصراف
          </CustomButton>
          <CustomButton
            className="w-50"
            buttonStyle="primary"
            state="default"
            size="medium"
            onClick={() => {
              DeleteAddress();
            }}
          >
            حذف آدرس
          </CustomButton>
        </div>
      </>
    </div>
  );
}
